<template>
  <main v-if="company">
    <router-view />
  </main>
</template>

<script>

import { mapState } from 'vuex'

import { companyRepository } from '@/repository/company'

export default {
  props: {
    companyId: { required: true }
  },
  computed: mapState({
    company: state => state.company.company
  }),
  created () {
    this.loadCompany()
  },
  watch: {
    companyId () {
      this.loadCompany()
    }
  },
  methods: {
    loadCompany () {
      this.$store.dispatch(companyRepository.find, { id: this.companyId })
    }
  }
}
</script>
